import { render, staticRenderFns } from "./CustomerTasksCompletedActivity.vue?vue&type=template&id=31465d17&scoped=true&"
import script from "./CustomerTasksCompletedActivity.vue?vue&type=script&lang=js&"
export * from "./CustomerTasksCompletedActivity.vue?vue&type=script&lang=js&"
import style0 from "../../../assets/style/base.css?vue&type=style&index=0&id=31465d17&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31465d17",
  null
  
)

export default component.exports